import React from "react";
import { Dialog, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { DraggableDialogContent } from "@/components/ui/draggable-dialog";
import { Button } from "@/components/ui/button";
import { Unpublish, ManageCampaignGetDetail } from "redux/actions";
import { useDispatch } from "react-redux";
import * as Constants from "utils/Constants";
import { trackPromise } from "react-promise-tracker";

const DesignUnpublishModal = (props) => {
  const {
    isAdhoc,
    isUnPublishPopupShow,
    toggleUnPublishPopup,
    design,
    clientId,
    startDate,
    endDate,
    isFromManageCampaigns,
  } = props;

  let modalTitle = "";
  let details = [];
  let completed = false;

  if (
    design?.status === Constants.emailStatus.Scheduled ||
    (design?.status === Constants.emailStatus.Recurring && !design.lastRunTime)
  ) {
    modalTitle = "Warning – Unpublishing an Email with No Sends";
    details = [];
    details.push(
      "Unpublishing this email stops any emails from being sent on this email's schedule."
    );
    details.push(
      "It will also remove all of the email's revenue from the campaign's total revenue. The email will appear in the Email Design library with a Draft status."
    );
    details.push(
      "Any changes in revenue totals as a result of this change may take up to 24 hours to update."
    );
    completed = false;
  }
  // if (design?.status === Constants.emailStatus.Recurring && isAdhoc) {
  //   modalTitle = "Warning – Unpublishing an Uncategorized Email with Sends";
  //   details.push(
  //     "Unpublishing this email will immediately stop any additional emails from sending on this schedule."
  //   );
  //   details.push("The email status will be changed to Expired. ");
  //   expired = true;
  // }
  if (
    design?.status === Constants.emailStatus.Recurring &&
    design.lastRunTime
  ) {
    modalTitle = "Warning – Unpublishing an Email with Sends";
    details.push(
      "Unpublishing this email will immediately stop any additional emails from sending on this schedule"
    );
    completed = false;
  }
  details.push("Do you want to continue?");

  const dispatch = useDispatch();

  const onUnpublishSubmit = (e) => {
    e.preventDefault();
    trackPromise(
      dispatch(
        Unpublish(
          clientId,
          design.designId ? design.designId : design.templateID,
          completed
        )
      ).then(() => {
        if (isFromManageCampaigns) {
          toggleUnPublishPopup();
          trackPromise(
            dispatch(
              ManageCampaignGetDetail(startDate, endDate, clientId, isAdhoc)
            )
          );
        } else {
          toggleUnPublishPopup();
          props.refreshDesignList();
        }
      })
    );
  };

  return (
    <Dialog open={isUnPublishPopupShow} onOpenChange={(open) => { if (!open) toggleUnPublishPopup(); }}>
      <DraggableDialogContent size="lg">
        <form onSubmit={onUnpublishSubmit}>
          <DialogHeader>
            <DialogTitle>
              <div className="modal-title">
                <div className="unsubscribe-title">{modalTitle}</div>
              </div>
            </DialogTitle>
          </DialogHeader>

          <div className="mb-3">
            {details.map((detail) => {
              return <p>{detail}</p>;
            })}
          </div>

          <DialogFooter>
            <Button type="submit">Yes, unpublish this email</Button>
            <Button
              type="button"
              variant="outline"
              onClick={(e) => {
                e.stopPropagation();
                toggleUnPublishPopup();
              }}
            >
              No, Cancel
            </Button>
          </DialogFooter>
        </form>
      </DraggableDialogContent>
    </Dialog>
  );
};

export default DesignUnpublishModal;
